// src/components/layout/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-800 text-gray-400 py-6">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <Link to="/" className="text-xl font-semibold text-gray-100">
              Esbjörn Falk
            </Link>
            <p className="text-sm mt-1">Classical Composer</p>
          </div>
          
          <div className="flex space-x-4 mb-4 md:mb-0">
            <Link to="/" className="hover:text-gray-100 transition-colors">Home</Link>
            <Link to="/discography" className="hover:text-gray-100 transition-colors">Discography</Link>
            <Link to="/about" className="hover:text-gray-100 transition-colors">About</Link>
          </div>
          
          <div className="text-sm">
            &copy; {currentYear} Esbjörn Falk. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;